import { render, staticRenderFns } from "./BaseFormGroupToggle.vue?vue&type=template&id=dc58433e"
import script from "./BaseFormGroupToggle.vue?vue&type=script&lang=js"
export * from "./BaseFormGroupToggle.vue?vue&type=script&lang=js"
import style0 from "./BaseFormGroupToggle.vue?vue&type=style&index=0&id=dc58433e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports